window.$ = window.jQuery = require('jquery');

window.VK = require('vk-openapi');

window.YandexMap = require('./modules/ymap');

window.Vue = require('vue');
window.Vue.component('main-search', require('./components/main-search/index').default);
window.Vue.component('tabs', require('./components/tabs').default);
window.Vue.component('tab', require('./components/tab').default);
window.Vue.component('quiz', require('./components/quiz').default);

window.swal = require('sweetalert2');
window.autosize = require('autosize').default;

require('@fancyapps/fancybox');
require('jquery-mask-plugin');
require('jquery-bar-rating');
require('tooltipster');

require('select2');
$.fn.select2.defaults.set('language', require('select2/src/js/select2/i18n/ru'));

require('./modules/jquery-settings')();
require('./modules/jquery-extensions')();